export const FINAL_RENDER_METRIC = 'web.frontend.final_render_latency_ms';
const MILESTONE_BY_METRIC = {
    'web.sse.start': 'STREAM_STARTED',
    'web.sse.connection_opened': 'STREAM_CONNECTION_OPENED',
    'web.sse.first_message_seen': 'STREAM_FIRST_MESSAGE',
    'web.frontend.first_token_latency_ms': 'CONTENT_FIRST_TOKEN_RECEIVED',
    'web.frontend.first_search_results_latency_ms': 'CONTENT_FIRST_SEARCH_RECEIVED',
    'web.frontend.first_output_token_latency_ms': 'CONTENT_FIRST_ANSWER_RECEIVED',
    'web.frontend.first_answer_candidate_latency_ms': 'CONTENT_FIRST_ANSWER_CANDIDATE_RECEIVED',
    'web.frontend.first_widget_data_latency_ms': 'CONTENT_FIRST_WIDGET_RECEIVED',
    'web.frontend.first_useful_renderable_content_latency_ms': 'CONTENT_FIRST_USEFUL_RECEIVED',
    'web.sse.end_of_stream': 'STREAM_END_RECEIVED',
    [FINAL_RENDER_METRIC]: 'CONTENT_FINAL_RENDER',
};
const OUTCOME_MILESTONES = new Set([
    'STREAM_END_RECEIVED',
    'CONTENT_FINAL_RENDER',
]);
export function captureBrowserLifecycleTerminal(stream) {
    return {
        local_elapsed_ms: Math.max(0, performance.now() - stream.timer.getStartTimeFromTimeOrigin()),
        observed_at_epoch_ms: Date.now(),
    };
}
/**
 * Projects a stream's once-only timer events onto lifecycle milestones. The
 * first timing per milestone wins, so a reconnect-side re-emit of an SSE vital
 * cannot move an earlier observation. Aborted and errored streams often never
 * record `web.sse.end_of_stream`; the terminal observation then stands in for
 * it so the persisted lane always carries the outcome.
 */
export function buildBrowserLifecycleAttempt(stream, outcome, terminal) {
    const events = new Map();
    const startedAt = stream.timer.getAbsoluteStartTime();
    for (const event of stream.timer.getEvents()) {
        const milestone = MILESTONE_BY_METRIC[event.metricName];
        if (!milestone || events.has(milestone)) {
            continue;
        }
        events.set(milestone, {
            milestone,
            ...(OUTCOME_MILESTONES.has(milestone) ? { outcome } : {}),
            local_elapsed_ms: Math.max(0, Math.round(event.duration * 1000) / 1000),
            observed_at_epoch_ms: Math.round(event.absoluteTime ?? startedAt + event.duration),
        });
    }
    if (!events.has('STREAM_END_RECEIVED')) {
        events.set('STREAM_END_RECEIVED', {
            milestone: 'STREAM_END_RECEIVED',
            outcome,
            local_elapsed_ms: Math.round(terminal.local_elapsed_ms * 1000) / 1000,
            observed_at_epoch_ms: Math.round(terminal.observed_at_epoch_ms),
        });
    }
    return {
        request_id: stream.id.description,
        attempt_kind: stream.isReconnect ? 'RECONNECT' : 'INITIAL',
        events: [...events.values()].sort((a, b) => a.observed_at_epoch_ms - b.observed_at_epoch_ms),
    };
}
//# sourceMappingURL=browserLifecycleAttempt.js.map